var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavManageTools(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:none;}.a{stroke:#ff6262;opacity:0;}.b{stroke:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18177 23974)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-18177 -23974)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 32,
    height: 32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-18838.031 -24068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M667,112.25h9v-8h-9Zm1-7h7v6h-7Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(668.5 116.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(672.5 116.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(668.5 113.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(672.5 113.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(668.5 119.25)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(672.5 119.25)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.161,113.054a1,1,0,0,0-.981-.8H685v-12a3.5,3.5,0,0,0-3.5-3.5h-7a3.5,3.5,0,0,0-3.5,3.5v2h-4a2,2,0,0,0-2,2v9.292a2.985,2.985,0,0,0,.317,1.341L666,116.25v5a2,2,0,0,0,2,2h7a2,2,0,0,0,2-2v-5l.683-1.367a2.985,2.985,0,0,0,.317-1.341V104.25a2,2,0,0,0-2-2h-4v-2a2.5,2.5,0,0,1,2.5-2.5h7a2.5,2.5,0,0,1,2.5,2.5v12h-2.18a1,1,0,0,0-.981.8l-.839,4.2v3a1,1,0,0,0,1,1v2h7v-2a1,1,0,0,0,1-1v-3ZM676,103.25a1,1,0,0,1,1,1v9.292a2.009,2.009,0,0,1-.211.894l-.683,1.367-.106.211v5.236a1,1,0,0,1-1,1h-7a1,1,0,0,1-1-1v-5.236l-.106-.211-.683-1.367a2.009,2.009,0,0,1-.211-.894V104.25a1,1,0,0,1,1-1Zm11,19h-5v-1h5Zm1-2h-7v-2.9l.82-4.1h5.36l.82,4.1Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavManageTools);
export default __webpack_public_path__ + "static/media/nav-manage-tools.f3fd952b125506a92daf19d34068f573.svg";
export { ForwardRef as ReactComponent };